import { dataHooks } from '../../../../libs/dataHooks';

export const forYouPageSectionDataHooks = dataHooks<{
  heading;
}>('forYouPageSection');
